import React from "react";
import { Link } from "react-router-dom";
import InnerHero from "../components/InnerHero";
import {
  ArrowLeft,
  Images,
  Wrench,
  Settings,
  Car,
} from "lucide-react";

const infrastructureImages = [
  {
    src: "/Infrastructure/COE_Royal_Enfield/RE1.png",
    //title: "Royal Enfield Centre of Excellence",
    //alt: "Royal Enfield Centre of Excellence",
  },
  {
    src: "/Infrastructure/COE_Royal_Enfield/RE3.png",
    //title: "Engine Assembly Section",
    //alt: "Engine Assembly Section",
  },
  {
    src: "/Infrastructure/COE_Royal_Enfield/RE2.png",
    //title: "Automotive Training Facility",
    //alt: "Automotive Training Facility",
  },
  {
    src: "/Infrastructure/COE_Royal_Enfield/RE4.JPG",
    ///title: "Automotive Training Facility",
    //alt: "Automotive Training Facility",
  },
];

const facilities = [
  "Royal Enfield Centre of Excellence",
  "Engine Assembly and Disassembly Units",
  "Vehicle Diagnostics Equipment",
  "Automotive Training Facility",
  "Workshop Infrastructure",
  "Industry-Oriented Skill Development Programs",
  "Hands-on Learning Environment",
  "Industry Collaboration Support",
];

const COERoyalEnfieldInfrastructure = () => (
  <main>
    <InnerHero
      title="Royal Enfield Centre of Excellence Infrastructure"
      image="/Infrastructure/COE_Royal_Enfield/RE1.png"
      breadcrumbs={[
        { label: "Academics", to: "/academics" },
        { label: "Centre of Excellence", to: "/centre-of-excellence" },
        { label: "Royal Enfield", to: "/coe/royal-enfield-training-centre" },
        { label: "Infrastructure" },
      ]}
    />

    <section className="bg-surface-alt/60 border-b border-brand/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-3 text-xs font-sans-ui font-semibold tracking-wider text-brand">
        <Link
          to="/coe/royal-enfield-training-centre"
          className="inline-flex items-center gap-2 uppercase hover:underline"
        >
          <ArrowLeft size={14} />
          Back to Centre of Excellence
        </Link>
      </div>
    </section>

    <section className="max-w-7xl mx-auto px-6 lg:px-10 py-12">
      <div className="grid lg:grid-cols-3 gap-10">
        <div className="lg:col-span-2 space-y-10">
          <section>
            <div className="flex items-end justify-between gap-4 mb-5">
              <div>
                <h2
                  className="text-2xl md:text-3xl text-brand font-semibold flex items-center gap-2"
                  style={{ fontFamily: "'Cormorant Garamond', serif" }}
                >
                  <Images size={22} />
                  Infrastructure Gallery
                </h2>

                <p className="text-sm text-[#3a3a3a]/80 italic mt-1">
                  Royal Enfield Centre of Excellence facilities and training environment
                </p>
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-4">
              {infrastructureImages.map((image) => (
                <figure
                  key={image.src}
                  className="bg-white border border-brand/15 overflow-hidden"
                >
                  <div className="aspect-[16/10] overflow-hidden">
                    <img
                      src={image.src}
                      alt={image.alt}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>

                  {/* <figcaption className="px-4 py-3">
                    <span className="text-xs uppercase tracking-widest text-brand font-semibold">
                      {image.title}
                    </span>
                  </figcaption> */}
                </figure>
              ))}
            </div>
          </section>

          <section>
            <h2
              className="text-2xl md:text-3xl text-brand font-semibold flex items-center gap-2 mb-5"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              <Wrench size={22} />
              Facilities
            </h2>

            <div className="bg-white border border-brand/15 p-5">
              <ul className="grid md:grid-cols-2 gap-x-6 gap-y-2 pl-5 list-disc text-sm text-[#2a2a2a]/85 leading-relaxed">
                {facilities.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
          </section>
        </div>

        <aside className="space-y-5">
          <div className="bg-white border border-brand/15 p-5 lg:sticky lg:top-36 self-start">
            <h4 className="text-xs uppercase tracking-widest text-brand font-semibold">
              Infrastructure Facts
            </h4>

            <div className="mt-3 space-y-3 text-sm">
              <div className="flex items-center gap-2">
                <Car size={14} className="text-brand" />
                <span>
                  Industry Partner: <strong>Royal Enfield</strong>
                </span>
              </div>

              <div>
                Training Facility: <strong>Available</strong>
              </div>

              <div>
                Engine Lab: <strong>Available</strong>
              </div>

              <div>
                Workshop Setup: <strong>Available</strong>
              </div>

              <div>
                Industry Exposure: <strong>Available</strong>
              </div>
            </div>

            <Link
              to="/coe/royal-enfield-training-centre"
              className="block mt-5 text-center bg-brand text-surface py-2.5 text-sm font-semibold hover:bg-brand-dark transition"
            >
              CoE Overview
            </Link>

            <div className="mt-6 pt-5 border-t border-brand/10">
              <h4 className="text-xs uppercase tracking-widest text-brand font-semibold mb-3">
                Key Facilities
              </h4>

              <ul className="space-y-1.5 text-sm text-[#2a2a2a]">
                {[
                  "Engine Assembly Unit",
                  "Vehicle Diagnostics",
                  "Workshop Facility",
                  "Automotive Training",
                  "Skill Development",
                  "Industry Projects",
                ].map((item) => (
                  <li key={item} className="flex items-center gap-1">
                    <Settings size={12} className="text-brand" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </aside>
      </div>
    </section>
  </main>
);

export default COERoyalEnfieldInfrastructure;
